import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  clearPanelSession,
  fetchPanelSession,
  getPanelSession,
  hasPanelAccess,
} from '@/utils/panelSession'
import canAccessScope from '@/utils/panelPermissions'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/login',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'Dashboard',
      authScope: 'panel',
    },
    component: () => import('@/views/dashboard/Dashboard.vue'),
  },
  {
    path: '/userList',
    name: 'userList',
    meta: {
      title: 'Kullanıcı Listesi',
      authScope: 'admin',
    },
    component: () => import('@/views/users/UserList.vue'),
  },
  {
    path: '/points',
    name: 'points',
    meta: {
      title: 'Puan Yönetimi',
      authScope: 'admin',
    },
    component: () => import('@/views/points/PointsManagement.vue'),
  },
  {
    path: '/achievements',
    name: 'achievements',
    meta: {
      title: 'Başarımlar',
      authScope: 'admin',
    },
    component: () => import('@/views/achievements/AchievementsManagement.vue'),
  },
  {
    path: '/premium',
    name: 'premium',
    meta: {
      title: 'Premium',
      authScope: 'admin',
    },
    component: () => import('@/views/premium/PremiumManagement.vue'),
  },
  {
    path: '/premium/:premiumId(\\d+)',
    name: 'premium-detail',
    meta: { title: 'Premium detayı', authScope: 'admin' },
    component: () => import('@/views/premium/PremiumDetailPage.vue'),
  },
  {
    path: '/referralReviews',
    alias: '/referral-inceleme',
    name: 'referralReviews',
    meta: {
      title: 'Referral İnceleme',
      authScope: 'admin',
    },
    component: () => import('@/views/referrals/ReferralReviews.vue'),
  },
  {
    path: '/campaignsList',
    name: 'campaignsList',
    meta: {
      title: 'Adverport Kampanyaları',
      authScope: 'panel',
    },
    component: () => import('@/views/campaigns/CampaignsList.vue'),
  },
  {
    path: '/campaign-url-health',
    name: 'campaignUrlHealth',
    meta: {
      title: 'Kampanya URL Sağlığı',
      authScope: 'admin',
    },
    component: () => import('@/views/campaigns/CampaignUrlHealth.vue'),
  },
  {
    path: '/carouselCampaigns',
    redirect: { name: 'campaignsList' },
  },
  {
    path: '/passiveCampaign',
    redirect: { name: 'campaignsList' },
  },
  {
    path: '/companiesList',
    name: 'companiesList',
    meta: {
      title: 'Network Offer\'lar',
      authScope: 'panel',
    },
    component: () => import('@/views/companies/Companies.vue'),
  },
  {
    path: '/linkReports',
    name: 'linkReports',
    meta: {
      title: 'Link Raporları',
      authScope: 'admin',
    },
    component: () => import('@/views/reports/LinkReports.vue'),
  },
  {
    path: '/analyticsEvents',
    name: 'analyticsEvents',
    meta: {
      title: 'Analytics Eventleri',
      authScope: 'admin',
    },
    component: () => import('@/views/analytics/AnalyticsEvents.vue'),
  },
  {
    path: '/analyticsJourneys',
    name: 'analyticsJourneys',
    meta: {
      title: 'Analytics Journeyleri',
      authScope: 'admin',
    },
    component: () => import('@/views/analytics/Journeys.vue'),
  },
  {
    path: '/analyticsMail',
    name: 'analyticsMail',
    meta: {
      title: 'Mail Analitiği',
      authScope: 'admin',
    },
    component: () => import('@/views/analytics/MailAnalytics.vue'),
  },

  {
    path: '/cashTransfer',
    name: 'cashTransfer',
    meta: {
      title: 'Para Transfer İstekleri',
      authScope: 'finance',
    },
    component: () => import('@/views/cashTransfer/CashTransferList.vue'),
  },
  {
    path: '/walletReports',
    name: 'walletReports',
    meta: {
      title: 'Cüzdan Raporları',
      authScope: 'finance',
    },
    component: () => import('@/views/reports/WalletReports.vue'),
  },
  {
    path: '/garanti-account',
    name: 'garantiAccount',
    meta: { title: 'Garanti Hesabı', authScope: 'finance' },
    component: () => import('@/views/reports/GarantiAccount.vue'),
  },
  {
    path: '/parasut/supplier-payments',
    name: 'parasutSupplierPayments',
    redirect: { name: 'parasutExpenses' },
  },
  {
    path: '/parasut/expenses',
    name: 'parasutExpenses',
    meta: { title: 'Giderler', authScope: 'finance' },
    props: { kind: 'expenses' },
    component: () => import('@/views/reports/ParasutDocuments.vue'),
  },
  {
    path: '/parasut/sales-invoices',
    name: 'parasutSalesInvoices',
    meta: { title: 'Satış Faturaları', authScope: 'finance' },
    props: { kind: 'sales-invoices' },
    component: () => import('@/views/reports/ParasutDocuments.vue'),
  },
  {
    path: '/settlements',
    alias: '/mutabakat',
    name: 'settlements',
    meta: {
      title: 'Mutabakat',
      authScope: 'finance',
    },
    component: () => import('@/views/settlements/SettlementApproval.vue'),
  },
  {
    path: '/conversions',
    name: 'conversions',
    meta: { title: 'Conversionlar', authScope: 'finance' },
    component: () => import('@/views/reports/ConversionReports.vue'),
  },
  {
    path: '/banks',
    name: 'banks',
    meta: {
      title: 'Bankalar',
      authScope: 'admin',
    },
    component: () => import('@/views/banks/BankList.vue'),
  },
  {
    path: '/categories',
    name: 'categories',
    meta: {
      title: 'Kategoriler',
      authScope: 'admin',
    },
    component: () => import('@/views/categories/CategoriesList.vue'),
  },
  {
    path: '/broadcastNotifications',
    name: 'broadcastNotifications',
    meta: {
      title: 'Bildirimler',
      authScope: 'admin',
    },
    component: () => import('@/views/notifications/BroadcastNotifications.vue'),
  },
  {
    path: '/newsletterSubscribers',
    name: 'newsletterSubscribers',
    meta: { title: 'Bülten Aboneleri', authScope: 'admin' },
    component: () => import('@/views/notifications/NewsletterSubscribers.vue'),
  },
  {
    path: '/contactRequests',
    name: 'contactRequests',
    meta: { title: 'İletişim Talepleri', authScope: 'admin' },
    component: () => import('@/views/support/WebsiteContactRequests.vue'),
  },
  {
    path: '/whatsappSupport',
    name: 'whatsappSupport',
    meta: {
      title: 'WhatsApp Destek',
      authScope: 'admin',
    },
    component: () => import('@/views/support/WhatsAppSupportInbox.vue'),
  },
  {
    path: '/logExplorer',
    name: 'logExplorer',
    meta: {
      title: 'Log Explorer',
      authScope: 'admin',
    },
    component: () => import('@/views/system/LogExplorer.vue'),
  },
  {
    path: '/cronMonitor',
    name: 'cronMonitor',
    meta: {
      title: 'Cron Job İzleyici',
      authScope: 'admin',
    },
    component: () => import('@/views/system/CronMonitor.vue'),
  },
  {
    path: 'banks/add',
    name: 'add',
    meta: {
      title: 'Yeni Banka Ekle',
    },
    component: () => import('@/views/banks/BankForm.vue'),
  },
  {
    path: '/settings',
    alias: '/pages/account-settings',
    name: 'settings',
    meta: {
      title: 'Hesap Ayarları',
      authScope: 'panel',
    },
    component: () => import('@/views/pages/account-settings/AccountSettings.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/pages/register',
    name: 'pages-register',
    component: () => import('@/views/pages/Register.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

const publicRouteNames = new Set(['login', 'pages-register', 'error-404'])

router.beforeEach(async (to, from, next) => {
  const isPublicRoute = publicRouteNames.has(to.name)

  if (to.name === 'login' && to.query?.reset === '1') {
    clearPanelSession()
    next()

    return
  }

  let panelSession = getPanelSession()
  let hasSession = hasPanelAccess(panelSession)

  if ((to.name === 'login' || !isPublicRoute) && !hasSession) {
    try {
      panelSession = await fetchPanelSession()
      hasSession = hasPanelAccess(panelSession)
    } catch (error) {
      clearPanelSession()
      panelSession = null
      hasSession = false
    }
  }

  if (to.name === 'login' && hasSession) {
    next({ name: 'dashboard' })

    return
  }

  if (!isPublicRoute && !hasSession) {
    clearPanelSession()
    next({ name: 'login' })

    return
  }

  const routeScope = to.meta?.authScope || 'panel'

  if (!isPublicRoute && !canAccessScope(routeScope, panelSession)) {
    next({ name: 'dashboard' })

    return
  }

  next()
})

export default router
